<script>
import SideMenuItem from '../side-menu-item';
import Config       from '../../../../libs/config';

export default {
  name  : 'side-menu-item-account-edit',
  mixins: [SideMenuItem],
  data  : function() {
    const link = new URL(Config.SERVICE_LINK.AUTH.ACCOUNT.URL);
    link.searchParams.set('client_id', this.$store.state.platformApi.clientId);
    return {
      label    : 'アカウント設定',
      link     : link.href,
      analytics: { label: 'side_menu_item_atcosme_account_edit' },
    };
  },
};
</script>
